var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PDFViewer',{staticStyle:{"height":"100vh","width":"100vw"},attrs:{"loading-text":"Loading","rendering-text":"Loading","source":_vm.fileBase64}})
}
var staticRenderFns = []

export { render, staticRenderFns }